import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { Utils } from '@src/utils/util';
import { LegendComponent} from './legend'
import {HttpClientModule} from '@angular/common/http';

@NgModule({
    imports: [SharedModule, HttpClientModule ],
    declarations: [LegendComponent],
    entryComponents: [LegendComponent],
    exports: [LegendComponent],
    providers: [ Utils]
})

export class LegendModule{}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/pipeline/legend-ang7/legend.module.ts